<section class="vh-100 d-flex align-items-center justify-content-center body-container">
  <div class="container-fluid text-center">
    <img src="assets/images/500.png" alt="404 Error" class="img-fluid">
  </div>
</section>
